export default __webpack_public_path__ + "static/media/Rewards.39c0fcfe.jpg";